
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import Navbar from '../components/Navbar';
import { toast } from 'sonner';
import { User, IdentificationCard } from '@phosphor-icons/react';

export default function CompleteProfile() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCurrent = async () => {
      try {
        const res = await api.get('/auth/me');
        if (res.data) {
          setName(res.data.name || '');
          setUsername(res.data.username || '');
        }
      } catch (err) {
        navigate('/login');
      }
    };
    fetchCurrent();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/complete-onboarding', { name, username });
      toast.success('Profil berhasil diatur!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal mengatur profil');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-md mx-auto px-4 py-12 md:py-16">
        <div className="border-2 border-foreground bg-white shadow-brutal-lg p-8">
          <p className="text-xs uppercase tracking-[0.3em] font-bold mb-2">Langkah Terakhir</p>
          <h1 className="font-display text-4xl font-bold tracking-tight mb-4">
            Lengkapi Profilmu.
          </h1>
          <p className="text-sm text-muted-foreground mb-8">
            Pilih nama dan username unik untuk mulai menerima traktiran.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="text-xs uppercase tracking-widest font-bold block mb-2">Nama Tampil</label>
              <div className="relative">
                <IdentificationCard size={18} weight="bold" className="absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full border-2 border-foreground bg-white pl-10 pr-4 py-3 shadow-brutal-sm focus:outline-none focus:border-primary focus:shadow-none focus:translate-x-[2px] focus:translate-y-[2px] transition-all"
                  placeholder="Contoh: Budi Santoso"
                />
              </div>
            </div>

            <div>
              <label className="text-xs uppercase tracking-widest font-bold block mb-2">Username</label>
              <div className="relative">
                <User size={18} weight="bold" className="absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value.toLowerCase())}
                  className="w-full border-2 border-foreground bg-white pl-10 pr-4 py-3 shadow-brutal-sm focus:outline-none focus:border-primary focus:shadow-none focus:translate-x-[2px] focus:translate-y-[2px] transition-all"
                  placeholder="budisantoso"
                />
              </div>
              <p className="mt-2 text-[10px] text-muted-foreground uppercase font-bold tracking-widest">
                traktirkan.id/u/{username || 'username'}
              </p>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full border-2 border-foreground bg-primary text-white px-4 py-3 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] active:shadow-none active:translate-x-[4px] active:translate-y-[4px] transition-all disabled:opacity-60"
            >
              {loading ? 'Menyimpan...' : 'Mulai Sekarang'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
